module.exports = __webpack_public_path__ + "static/media/huanguo.472fbf0c.jpg";